import { Component } from "react";
import withAuth from "../components/withAuth";
import "../components/Parameters.css";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from "./Layout/FooterFixedOnScreen";
import { compose } from "redux";
import System from "../components/System/System";
import { exportDb } from "../exportDbHelper";

class Parameters extends Component {
    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="container container-with-footer">
                    <System />
                </div>
                <FooterFixedOnScreen>
                    <div className="row">
                        <div className=" col-lg-3 col-md-4 col-sm-6 col-6">
                            <Fab onClick={exportDb.bind(true)} color="primary" className="div-center">
                                <Icon>download</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Exporter les données</span>
                        </div>
                    </div>
                </FooterFixedOnScreen>
            </div>
        );
    }
}

export default compose(withAuth)(Parameters);
